import { createRouter, createWebHashHistory, createWebHistory, RouteRecordRaw } from "vue-router";

import Main from "@/views/main.vue";
import Login from "@/views/login.vue";
import Join from "@/views/join.vue";

import Intro from "@/views/intro.vue";
import FaqView from "@/views/intro/faqView.vue";
import FaqWrite from "@/views/intro/faqWrite.vue";
import News from "@/views/news.vue";
import NewsView from "@/views/news/newsView.vue";
import NewsWrite from "@/views/news/newsWrite.vue";

import ArchiveList from "@/views/archive/list.vue";
import ArchiveWrite from "@/views/archive/write.vue";
import ArchiveView from "@/views/archive/detail.vue";

import Mypage from "@/views/mypage.vue";
import Report from "@/views/report.vue";
import Board from "@/views/board.vue";
import AdWrite from "@/views/report/adWrite.vue";
import AreaWrite from "@/views/report/areaWrite.vue";
import AreaView from "@/views/report/areaView.vue";
import AdView from "@/views/report/adView.vue";

import ActivityView from "@/views/board/activityView.vue";
import ActivityWrite from "@/views/board/activityWrite.vue";
import EventView from "@/views/board/eventView.vue";
import EventWrite from "@/views/board/eventWrite.vue";
import SuggestView from "@/views/board/suggestView.vue";
import SuggestWrite from "@/views/board/suggestWrite.vue";

import ActionView from "@/views/board/actionView.vue";
import ActionWrite from "@/views/board/actionWrite.vue";

import { userStore } from "@/BaseComponent";
import InquiryWrite from "@/views/components/mypage/inquiryWrite.vue";

const routes: Array<RouteRecordRaw> = [
    { path: "/", name: "Main", component: Main },
    {
        path: "/login",
        name: "Login",
        component: Login,
        meta: { requiresAuth: false },
    },
    { path: "/join", name: "Join", component: Join, meta: { requiresAuth: false } },
    { path: "/mypage", name: "Mypage", component: Mypage, meta: { requiresAuth: true, headerClass: ["_transparent", "sub_mypage"] } },

    {
        path: "/inquiryWrite",
        name: "inquiryWrite",
        component: InquiryWrite,
        meta: { requiresAuth: true, headerClass: ["_transparent", "sub_mypage"] },
    },

    { path: "/report", name: "Report", component: Report, meta: { requiresAuth: false, headerClass: ["_transparent", "sub_report"] } },
    { path: "/intro", name: "Intro", component: Intro, meta: { requiresAuth: false, headerClass: ["_transparent", "sub_intro"] } },
    { path: "/news", name: "News", component: News, meta: { requiresAuth: false, headerClass: ["_transparent", "sub_news"] } },
    { path: "/board", name: "Board", component: Board, meta: { requiresAuth: false, headerClass: ["_transparent", "sub_board"] } },

    { path: "/faqList", name: "FaqList", component: Intro, meta: { requiresAuth: false, headerClass: ["_transparent", "sub_intro"] } },
    { path: "/faqView/:id", name: "FaqView", component: FaqView, meta: { requiresAuth: false, headerClass: ["_transparent", "sub_intro"] } },
    { path: "/faqWrite", name: "FaqWrite", component: FaqWrite, meta: { requiresAuth: true, headerClass: ["_transparent", "sub_intro"] } },
    { path: "/faqModify/:id", name: "FaqModify", component: FaqWrite, meta: { requiresAuth: true, headerClass: ["_transparent", "sub_intro"] } },

    { path: "/newsView/:id", name: "NewsView", component: NewsView, meta: { requiresAuth: false, headerClass: ["_transparent", "sub_news"] } },
    { path: "/newsWrite", name: "NewsWrite", component: NewsWrite, meta: { requiresAuth: true, headerClass: ["_transparent", "sub_news"] } },
    { path: "/newsModify/:id", name: "NewsModify", component: NewsWrite, meta: { requiresAuth: true, headerClass: ["_transparent", "sub_news"] } },

    { path: "/archive", name: "Archive", component: ArchiveList, meta: { requiresAuth: false, headerClass: ["_transparent"] } },
    {
        path: "/archiveWrite",
        name: "ArchiveWrite",
        component: ArchiveWrite,
        meta: { requiresAuth: true, headerClass: ["_transparent"] },
    },
    {
        path: "/archiveModify/:id",
        name: "ArchiveModify",
        component: ArchiveWrite,
        meta: { requiresAuth: true, headerClass: ["_transparent"] },
    },
    {
        path: "/archiveView/:id",
        name: "ArchiveView",
        component: ArchiveView,
        meta: { requiresAuth: false, headerClass: ["_transparent"] },
    },

    { path: "/areaWrite", name: "AreaWrite", component: AreaWrite, meta: { requiresAuth: false, headerClass: ["_transparent", "sub_report"] } },
    { path: "/areaModify/:id", name: "AreaModify", component: AreaWrite, meta: { requiresAuth: false, headerClass: ["_transparent", "sub_report"] } },
    { path: "/areaView/:id", name: "AreaView", component: AreaView, meta: { requiresAuth: false, headerClass: ["_transparent", "sub_report"] } },
    { path: "/adWrite", name: "AdWrite", component: AdWrite, meta: { requiresAuth: false, headerClass: ["_transparent", "sub_report"] } },
    { path: "/adModify/:id", name: "AdModify", component: AdWrite, meta: { requiresAuth: false, headerClass: ["_transparent", "sub_report"] } },
    { path: "/adView/:id", name: "AdView", component: AdView, meta: { requiresAuth: false, headerClass: ["_transparent", "sub_report"] } },

    {
        path: "/activityView/:id",
        name: "ActivityView",
        component: ActivityView,
        meta: { requiresAuth: false, headerClass: ["_transparent", "sub_board"] },
    },
    {
        path: "/activityWrite",
        name: "ActivityWrite",
        component: ActivityWrite,
        meta: { requiresAuth: true, headerClass: ["_transparent", "sub_board"] },
    },
    {
        path: "/activityModify/:id",
        name: "ActivityModify",
        component: ActivityWrite,
        meta: { requiresAuth: true, headerClass: ["_transparent", "sub_board"] },
    },
    { path: "/eventView/:id", name: "EventView", component: EventView, meta: { requiresAuth: false, headerClass: ["_transparent", "sub_board"] } },
    { path: "/eventWrite", name: "EventWrite", component: EventWrite, meta: { requiresAuth: true, headerClass: ["_transparent", "sub_board"] } },
    {
        path: "/eventModify/:id",
        name: "EventModify",
        component: EventWrite,
        meta: { requiresAuth: true, headerClass: ["_transparent", "sub_board"] },
    },
    {
        path: "/suggestView/:id",
        name: "SuggestView",
        component: SuggestView,
        meta: { requiresAuth: false, headerClass: ["_transparent", "sub_board"] },
    },
    {
        path: "/suggestWrite",
        name: "SuggestWrite",
        component: SuggestWrite,
        meta: { requiresAuth: true, headerClass: ["_transparent", "sub_board"] },
    },
    {
        path: "/suggestModify/:id",
        name: "SuggestModify",
        component: SuggestWrite,
        meta: { requiresAuth: false, headerClass: ["_transparent", "sub_board"] },
    },

    {
        path: "/actionView/:stateIdx/:id",
        name: "ActionView",
        component: ActionView,
        meta: { requiresAuth: false, headerClass: ["_transparent", "sub_board"] },
    },
    {
        path: "/actionWrite/:stateIdx",
        name: "ActionWrite",
        component: ActionWrite,
        meta: { requiresAuth: true, headerClass: ["_transparent", "sub_board"] },
    },
    {
        path: "/actionModify/:stateIdx/:id",
        name: "ActionModify",
        component: ActionWrite,
        meta: { requiresAuth: false, headerClass: ["_transparent", "sub_board"] },
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
    scrollBehavior() {
        return { top: 0 };
    },
});

// 라우터 네비게이션 가드 설정
router.beforeEach((to, from, next) => {
    const user = userStore();
    const isLoggedIn = user !== null && user.accessToken !== "" && user.accessToken !== null;
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        // 해당 라우트에 인증이 필요한 경우
        if (!isLoggedIn) {
            // 로그인이 되어 있지 않은 경우
            next({ name: "Login", query: { redirect: to.fullPath } }); // 로그인 페이지로 이동
        } else {
            next(); // 다음 단계로 이동
        }
    } else {
        next(); // 인증이 필요하지 않은 경우 다음 단계로 이동
    }
});

export default router;
